var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "business" }, [
    _c("form", [
      _c("h1", { staticClass: "f-weight__500 text-center font-small title" }, [
        _vm._v("买卖合同（一般货物）")
      ]),
      _c("div", { staticClass: "all-indent" }, [
        _c("div", { staticClass: "cel" }, [
          _c("div", { staticClass: "cel-content" }, [
            _vm._v("买方（下称甲方）：")
          ]),
          _c("div", { staticClass: "cel-content__full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.fpName,
                  expression: "form.fpName"
                }
              ],
              staticClass: "width-full",
              attrs: { type: "text", name: "fpName" },
              domProps: { value: _vm.form.fpName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "fpName", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "cel" }, [
          _c("div", { staticClass: "cel-content" }, [_vm._v("地址:")]),
          _c("div", { staticClass: "cel-content__full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.fpAddress,
                  expression: "form.fpAddress"
                }
              ],
              staticClass: "width-full",
              attrs: { type: "text", name: "fpAddress" },
              domProps: { value: _vm.form.fpAddress },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "fpAddress", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "cel" }, [
          _c("div", { staticClass: "cel-content" }, [_vm._v("电话:")]),
          _c("div", { staticClass: "cel-content__full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.fpMobile,
                  expression: "form.fpMobile"
                }
              ],
              staticClass: "width-full",
              attrs: { type: "text", name: "fpMobile" },
              domProps: { value: _vm.form.fpMobile },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "fpMobile", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "cel" }, [
          _c("div", { staticClass: "cel-content" }, [_vm._v("电子邮箱：")]),
          _c("div", { staticClass: "cel-content__full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.fpEmail,
                  expression: "form.fpEmail"
                }
              ],
              staticClass: "width-full",
              attrs: { type: "text", name: "fpEmail" },
              domProps: { value: _vm.form.fpEmail },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "fpEmail", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "cel" }, [
          _c("div", { staticClass: "cel-content" }, [
            _vm._v("卖方（下称乙方）：")
          ]),
          _c("div", { staticClass: "cel-content__full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.spName,
                  expression: "form.spName"
                }
              ],
              staticClass: "width-full",
              attrs: { type: "text", name: "spName" },
              domProps: { value: _vm.form.spName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "spName", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "cel" }, [
          _c("div", { staticClass: "cel-content" }, [_vm._v("地址：")]),
          _c("div", { staticClass: "cel-content__full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.spAddress,
                  expression: "form.spAddress"
                }
              ],
              staticClass: "width-full",
              attrs: { type: "text", name: "spAddress" },
              domProps: { value: _vm.form.spAddress },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "spAddress", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "cel" }, [
          _c("div", { staticClass: "cel-content" }, [_vm._v("电话：")]),
          _c("div", { staticClass: "cel-content__full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.spMobile,
                  expression: "form.spMobile"
                }
              ],
              staticClass: "width-full",
              attrs: { type: "text", name: "spMobile" },
              domProps: { value: _vm.form.spMobile },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "spMobile", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "cel" }, [
          _c("div", { staticClass: "cel-content" }, [_vm._v("电子邮箱：")]),
          _c("div", { staticClass: "cel-content__full" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.spEmail,
                  expression: "form.spEmail"
                }
              ],
              staticClass: "width-full",
              attrs: { type: "text", name: "spEmail" },
              domProps: { value: _vm.form.spEmail },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "spEmail", $event.target.value)
                }
              }
            })
          ])
        ])
      ]),
      _c("p", [
        _vm._v("甲乙双方经充分协商，本着自愿及平等互利的原则，订立本合同。")
      ]),
      _c("h5", [_vm._v("第一条 名称、品种、规格和质量")]),
      _c("p", [
        _vm._v("1.名称、品种、规格："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.guige,
              expression: "form.guige"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "guige" },
          domProps: { value: _vm.form.guige },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "guige", $event.target.value)
            }
          }
        }),
        _vm._v("（应注明产品的牌号或商标）。")
      ]),
      _c("p", [
        _vm._v("2.质量，按下列第（"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.djxzx,
              expression: "form.djxzx"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "djxzx" },
          domProps: { value: _vm.form.djxzx },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "djxzx", $event.target.value)
            }
          }
        }),
        _vm._v("）项执行：")
      ]),
      _c("p", [
        _vm._v("（1） 按照"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.andjxzx,
              expression: "form.andjxzx"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "andjxzx" },
          domProps: { value: _vm.form.andjxzx },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "andjxzx", $event.target.value)
            }
          }
        }),
        _vm._v(
          "标准执行（须注明按国家标准或部颁或企业具体标准，如标准代号、编号和标准名称等）。"
        )
      ]),
      _c("p", [
        _vm._v("（2） 按样本，样本作为合同的附件（应注明样本封存及保管方式）。")
      ]),
      _c("p", [
        _vm._v("（3） 按双方商定要求执行，具体为："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.sfyqzx,
              expression: "form.sfyqzx"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "sfyqzx" },
          domProps: { value: _vm.form.sfyqzx },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "sfyqzx", $event.target.value)
            }
          }
        }),
        _vm._v("（应具体约定产品质量要求）。")
      ]),
      _c("h5", [_vm._v("第二条 数量和计量单位、计量方法")]),
      _c("p", [
        _vm._v("1.数量："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.shuliang,
              expression: "form.shuliang"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "shuliang" },
          domProps: { value: _vm.form.shuliang },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "shuliang", $event.target.value)
            }
          }
        }),
        _vm._v("。")
      ]),
      _c("p", [
        _vm._v("2.计量单位和方法："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.jldwhff,
              expression: "form.jldwhff"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "jldwhff" },
          domProps: { value: _vm.form.jldwhff },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "jldwhff", $event.target.value)
            }
          }
        }),
        _vm._v("。")
      ]),
      _c("p", [
        _vm._v(
          "3.交货数量的正负尾差、合理磅差和在途自然增（减）量规定及计算方法："
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.jsff,
              expression: "form.jsff"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "jsff" },
          domProps: { value: _vm.form.jsff },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "jsff", $event.target.value)
            }
          }
        }),
        _vm._v("。")
      ]),
      _c("p", [
        _vm._v("第三条 包装方式和包装品的处理："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.bzfs,
              expression: "form.bzfs"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "bzfs" },
          domProps: { value: _vm.form.bzfs },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "bzfs", $event.target.value)
            }
          }
        }),
        _vm._v(
          "（应尽可能注明所采用的包装标准是否国家或主管部门标准，自行约定包装标准应具体可行，包装材料由谁供应，包装费用的负担。）。"
        )
      ]),
      _c("p", [_vm._v("第四条 交货方式：")]),
      _c("p", [
        _vm._v("1.交货时间："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.jhshijian,
              expression: "form.jhshijian"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "jhshijian" },
          domProps: { value: _vm.form.jhshijian },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "jhshijian", $event.target.value)
            }
          }
        }),
        _vm._v("。")
      ]),
      _c("p", [
        _vm._v("2.交货地点："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.jhaddress,
              expression: "form.jhaddress"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "jhaddress" },
          domProps: { value: _vm.form.jhaddress },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "jhaddress", $event.target.value)
            }
          }
        }),
        _vm._v("。")
      ]),
      _c("p", [
        _vm._v("3.运输方式："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.yunshufangshi,
              expression: "form.yunshufangshi"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "yunshufangshi" },
          domProps: { value: _vm.form.yunshufangshi },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "yunshufangshi", $event.target.value)
            }
          }
        }),
        _vm._v("（注明由谁负责代办运输）。")
      ]),
      _c("p", [
        _vm._v("4.保 险："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.insuranceName,
              expression: "form.insuranceName"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "insuranceName" },
          domProps: { value: _vm.form.insuranceName },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "insuranceName", $event.target.value)
            }
          }
        }),
        _vm._v("（按情况约定由谁负责投保并具体规定投保金额和投保险种）。")
      ]),
      _c("p", [
        _vm._v("5.与买卖相关的单证的转移："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.zhuanyi,
              expression: "form.zhuanyi"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "zhuanyi" },
          domProps: { value: _vm.form.zhuanyi },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "zhuanyi", $event.target.value)
            }
          }
        }),
        _vm._v("。")
      ]),
      _c("p", [_vm._v("第五条 验收：")]),
      _c("p", [
        _vm._v("1.验收时间："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.ysTime,
              expression: "form.ysTime"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "ysTime" },
          domProps: { value: _vm.form.ysTime },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "ysTime", $event.target.value)
            }
          }
        }),
        _vm._v("。")
      ]),
      _c("p", [
        _vm._v("2.验收方式："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.ysMethod,
              expression: "form.ysMethod"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "ysMethod" },
          domProps: { value: _vm.form.ysMethod },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "ysMethod", $event.target.value)
            }
          }
        }),
        _vm._v("（如采用抽样检验，应注明抽样标准或方法和比例）。")
      ]),
      _c("p", [
        _vm._v("3.验收如发生争议，由"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.jyjg,
              expression: "form.jyjg"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "jyjg" },
          domProps: { value: _vm.form.jyjg },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "jyjg", $event.target.value)
            }
          }
        }),
        _vm._v("检验机构按"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.jyfs,
              expression: "form.jyfs"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "jyfs" },
          domProps: { value: _vm.form.jyfs },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "jyfs", $event.target.value)
            }
          }
        }),
        _vm._v("检验标准和方法，对产品进行检验。")
      ]),
      _c("p", [_vm._v("第六条 价格与货款支付：")]),
      _c("p", [
        _vm._v("1.单价："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.perPrice,
              expression: "form.perPrice"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "perPrice" },
          domProps: { value: _vm.form.perPrice },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "perPrice", $event.target.value)
            }
          }
        }),
        _vm._v("；总价："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.totalPrice,
              expression: "form.totalPrice"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "totalPrice" },
          domProps: { value: _vm.form.totalPrice },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "totalPrice", $event.target.value)
            }
          }
        }),
        _vm._v("（明确币种及大写）。")
      ]),
      _c("p", [_vm._v("2.货款支付：")]),
      _c("p", [
        _vm._v("货款的支付时间："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.payTime,
              expression: "form.payTime"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "payTime" },
          domProps: { value: _vm.form.payTime },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "payTime", $event.target.value)
            }
          }
        }),
        _vm._v("；")
      ]),
      _c("p", [
        _vm._v("货款的支付方式："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.payMethod,
              expression: "form.payMethod"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "payMethod" },
          domProps: { value: _vm.form.payMethod },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "payMethod", $event.target.value)
            }
          }
        }),
        _vm._v("；")
      ]),
      _c("p", [
        _vm._v("运杂费和其它费用的支付时间及方式："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.zfsjfs,
              expression: "form.zfsjfs"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "zfsjfs" },
          domProps: { value: _vm.form.zfsjfs },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "zfsjfs", $event.target.value)
            }
          }
        }),
        _vm._v("；")
      ]),
      _c("p", [
        _vm._v("3.预付货款："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.yfhk,
              expression: "form.yfhk"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "yfhk" },
          domProps: { value: _vm.form.yfhk },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "yfhk", $event.target.value)
            }
          }
        }),
        _vm._v("（根据需要决定是否需要预付货款及金额、预付时间）。")
      ]),
      _c("p", [_vm._v("第七条 提出异议的时间和方法：")]),
      _c("p", [
        _vm._v(
          "\n      1.甲方在验收中如发现货物的品种、型号、规格、花色和质量不合规定或约定，应在妥为保管货物的同时，自收到货物后\n      "
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.yyTime,
              expression: "form.yyTime"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "andjxzx" },
          domProps: { value: _vm.form.yyTime },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "yyTime", $event.target.value)
            }
          }
        }),
        _vm._v(
          "\n      日内向乙方提出书面异议；在托收承付期间，甲方有权拒付不符合合同规定部分的货款。甲方未及时提出异议或者自收到货物之日起\n      "
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.wtzTime,
              expression: "form.wtzTime"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "wtzTime" },
          domProps: { value: _vm.form.wtzTime },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "wtzTime", $event.target.value)
            }
          }
        }),
        _vm._v("\n      日内未通知乙方的，视为货物合乎规定。\n    ")
      ]),
      _c("p", [
        _vm._v(
          "2.甲方因使用、保管、保养不善等造成产品质量下降的，不得提出异议。"
        )
      ]),
      _c("p", [
        _vm._v("3.乙方在接到甲方书面异议后，应在"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.clyyTime,
              expression: "form.clyyTime"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "clyyTime" },
          domProps: { value: _vm.form.clyyTime },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "clyyTime", $event.target.value)
            }
          }
        }),
        _vm._v(
          "日内负责处理并通知甲方处理情况，否则，即视为默认甲方提出的异议和处理意见。"
        )
      ]),
      _c("p", [_vm._v("第八条 甲方违约责任：")]),
      _c("p", [
        _vm._v("1.甲方中途退货的，应向乙方赔偿退货部分货款的"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.wyj,
              expression: "form.wyj"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "wyj" },
          domProps: { value: _vm.form.wyj },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "wyj", $event.target.value)
            }
          }
        }),
        _vm._v("％违约金。")
      ]),
      _c("p", [
        _vm._v(
          "\n      2.甲方未按合同约定的时间和要求提供有关技术资料、包装物的，除交货日期得以顺延外，应按顺延交货部分货款金额每日万分之\n      "
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.wjybl,
              expression: "form.wjybl"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "wjybl" },
          domProps: { value: _vm.form.wjybl },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "wjybl", $event.target.value)
            }
          }
        }),
        _vm._v("计算，向乙方支付违约金；如"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.wjyshijian,
              expression: "form.wjyshijian"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "wjyshijian" },
          domProps: { value: _vm.form.wjyshijian },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "wjyshijian", $event.target.value)
            }
          }
        }),
        _vm._v("\n      日内仍不能提供的，按中途退货处理。\n    ")
      ]),
      _c("p", [
        _vm._v(
          "\n      3.甲方自提产品未按乙方通知的日期或合同约定日期提货的，应按逾期提货部分货款金额每日万分之\n      "
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.yqbl,
              expression: "form.yqbl"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "yqbl" },
          domProps: { value: _vm.form.yqbl },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "yqbl", $event.target.value)
            }
          }
        }),
        _vm._v(
          "\n      计算，向乙方支付逾期提货的违约金，并承担乙方实际支付的代为保管、保养的费用。\n    "
        )
      ]),
      _c("p", [
        _vm._v("4.甲方逾期付款的，应按逾期货款金额每日万分之"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.yqfkbl,
              expression: "form.yqfkbl"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "yqfkbl" },
          domProps: { value: _vm.form.yqfkbl },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "yqfkbl", $event.target.value)
            }
          }
        }),
        _vm._v("计算，向乙方支付逾期付款的违约金。")
      ]),
      _c("p", [
        _vm._v("5.甲方违反合同规定拒绝接受货物的，应承担因此给乙方造成的损失。")
      ]),
      _c("p", [
        _vm._v(
          "6.甲方如错填到货的地点、接货人，或对乙方提出错误异议，应承担乙方因此所受到的实际损失。"
        )
      ]),
      _c("p", [
        _vm._v("7.其它约定："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.qtyueding,
              expression: "form.qtyueding"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "qtyueding" },
          domProps: { value: _vm.form.qtyueding },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "qtyueding", $event.target.value)
            }
          }
        }),
        _vm._v("。")
      ]),
      _c("p", [_vm._v("第九条 乙方的违约责任：")]),
      _c("p", [
        _vm._v("1.乙方不能交货的，向甲方偿付不能交货部分货款"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.yfwybl,
              expression: "form.yfwybl"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "yfwybl" },
          domProps: { value: _vm.form.yfwybl },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "yfwybl", $event.target.value)
            }
          }
        }),
        _vm._v("％的违约金。")
      ]),
      _c("p", [
        _vm._v(
          "2.乙方所交货物品种、型号、规格、花色、质量不符合同规定的，如甲方同意利用，应按质论价；甲方不能利用的，应根据具体情况，由乙方负责包换或包修，并承担修理、调换或退货而支付的实际费用。"
        )
      ]),
      _c("p", [
        _vm._v(
          "\n      3.乙方因货物包装不符合合同规定，须返修或重新包装的，乙方负责返修或重新包装，并承担因此支出的费用。\n      甲方不要求返修或重新包装而要求赔偿损失的，乙方应赔偿甲方该不合格包装物低于合格物的差价部分。因包装不当造成货物损坏或灭失的，由乙方负责赔偿。\n    "
        )
      ]),
      _c("p", [
        _vm._v(
          "\n      4.乙方逾期交货的，应按照逾期交货金额每日万分之\n      "
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.yfyqbl,
              expression: "form.yfyqbl"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "yfyqbl" },
          domProps: { value: _vm.form.yfyqbl },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "yfyqbl", $event.target.value)
            }
          }
        }),
        _vm._v(
          "\n      计算，向甲方支付逾期交货的违约金，并赔偿甲方因此所遭受的损失。如逾期超过\n      "
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.yfyqshijian,
              expression: "form.yfyqshijian"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "yfyqshijian" },
          domProps: { value: _vm.form.yfyqshijian },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "yfyqshijian", $event.target.value)
            }
          }
        }),
        _vm._v("\n      日，甲方有权终止合同并可就遭受的损失向乙方索赔。\n    ")
      ]),
      _c("p", [
        _vm._v(
          "5.乙方提前交的货物、多交的货物，如其品种、型号、规格、花色、质量不符合约定，甲方在代保管期间实际支付的保管、保养等费用以及非因甲方保管不善而发生的损失，均应由乙方承担。"
        )
      ]),
      _c("p", [
        _vm._v(
          "6.货物错发到货地点或接货人的，乙方除应负责运到合同规定的到货地点或接货人外，还应承担甲方因此多支付的实际合理费用和逾期交货的违约金。"
        )
      ]),
      _c("p", [
        _vm._v(
          "\n      7.乙方提前交货的，甲方接到货物后，仍可按合同约定的付款时间付款；\n      合同约定自提的，甲方可拒绝提货。乙方逾期交货的，乙方应在发货前与甲方协商，甲方仍需要货物的，乙方应按数补交，并承担逾期交货责任；\n      甲方不再需要货物的，应在接到乙方通知后"
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.yftzshijian,
              expression: "form.yftzshijian"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "yftzshijian" },
          domProps: { value: _vm.form.yftzshijian },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "yftzshijian", $event.target.value)
            }
          }
        }),
        _vm._v(
          "日内通知乙方，办理解除合同手续，逾期不答复的，视为同意乙方发货。\n    "
        )
      ]),
      _c("p", [
        _vm._v("8.其它："),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.otherWyzr,
              expression: "form.otherWyzr"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "otherWyzr" },
          domProps: { value: _vm.form.otherWyzr },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "otherWyzr", $event.target.value)
            }
          }
        }),
        _vm._v("。")
      ]),
      _c("p", [_vm._v("第十条 不可抗力：")]),
      _c("p", [
        _vm._v(
          "\n      任何一方由于不可抗力原因不能履行合同时，应在不可抗力事件结束后"
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.tbshijian,
              expression: "form.tbshijian"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "tbshijian" },
          domProps: { value: _vm.form.tbshijian },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "tbshijian", $event.target.value)
            }
          }
        }),
        _vm._v(
          "日内向对方通报，\n      以减轻可能给对方造成的损失，在取得有关机构的不可抗力证明后，允许延期履行、部分履行或者不履行合同，并根据情况可部分或全部免予承担违约责任。\n    "
        )
      ]),
      _c("p", [_vm._v("第十一条 争议解决：")]),
      _c("p", [
        _vm._v(
          "凡因本合同引起的或与本合同有关的任何争议，如双方不能通过友好协商解决，均应提交中国国际经济贸易仲裁委员会深圳分会，按照申请仲裁时该会实行的仲裁规则进行仲裁。仲裁裁决是终局的，对双方均有约束力。"
        )
      ]),
      _c("p", [_vm._v("第十二条 附加条款：")]),
      _c("p", [
        _vm._v("1."),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.fjtkA,
              expression: "form.fjtkA"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "fjtkA" },
          domProps: { value: _vm.form.fjtkA },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "fjtkA", $event.target.value)
            }
          }
        }),
        _vm._v("。")
      ]),
      _c("p", [
        _vm._v("2."),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.fjtkB,
              expression: "form.fjtkB"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "fjtkB" },
          domProps: { value: _vm.form.fjtkB },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "fjtkB", $event.target.value)
            }
          }
        }),
        _vm._v("。")
      ]),
      _c("p", [
        _vm._v("3."),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.fjtkC,
              expression: "form.fjtkC"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "fjtkC" },
          domProps: { value: _vm.form.fjtkC },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "fjtkC", $event.target.value)
            }
          }
        }),
        _vm._v("。")
      ]),
      _c("p", [_vm._v("第十三条 其它事项：")]),
      _c("p", [
        _vm._v(
          "1.按本合同规定应付的违约金、赔偿金、保管保养费和各种经济损失，应当在明确责任后"
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.mqzrr,
              expression: "form.mqzrr"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "mqzrr" },
          domProps: { value: _vm.form.mqzrr },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "mqzrr", $event.target.value)
            }
          }
        }),
        _vm._v("日内，按银行规定的结算办法付清，否则按逾期付款处理。")
      ]),
      _c("p", [
        _vm._v(
          "\n      2.约定的违约金，视为违约的损失赔偿。双方没有约定违约金或预先赔偿额的计算方法的，损失赔偿额应当相当于违约所造成的损失，包括合同履行后可获得的利益，\n      但不得超过违反合同一方订立合同时应当预见到的因违反合同可能造成的损失。\n    "
        )
      ]),
      _c("p", [
        _vm._v("3.本合同自"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.shengxiaoshijian,
              expression: "form.shengxiaoshijian"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "shengxiaoshijian" },
          domProps: { value: _vm.form.shengxiaoshijian },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "shengxiaoshijian", $event.target.value)
            }
          }
        }),
        _vm._v(
          "日起生效，合同有效期内，除非经过对方同意，或者另有法定理由，任何一方不得变更或解除合同。"
        )
      ]),
      _c("p", [
        _vm._v(
          "4．合同如有未尽事宜，须经双方共同协商，作出补充规定，补充规定与本合同具有同等效力。"
        )
      ]),
      _c("p", [
        _vm._v("\n      5．双方来往函件，按照合同规定的地址或传真号码以"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.cdfs,
              expression: "form.cdfs"
            }
          ],
          staticClass: "width-medium",
          attrs: { type: "text", name: "cdfs" },
          domProps: { value: _vm.form.cdfs },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "cdfs", $event.target.value)
            }
          }
        }),
        _vm._v(
          "方式送达对方。如一方地址、电话、传真号码有变更，应在变更后的\n      "
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.bgshijian,
              expression: "form.bgshijian"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "bgshijian" },
          domProps: { value: _vm.form.bgshijian },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "bgshijian", $event.target.value)
            }
          }
        }),
        _vm._v("日内书面通知对方，否则，应承担相应责任。\n    ")
      ]),
      _c("p", [
        _vm._v("6．本合同正本一式"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.contractNum,
              expression: "form.contractNum"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "contractNum" },
          domProps: { value: _vm.form.contractNum },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "contractNum", $event.target.value)
            }
          }
        }),
        _vm._v("份，双方各执"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.sfgzfs,
              expression: "form.sfgzfs"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "sfgzfs" },
          domProps: { value: _vm.form.sfgzfs },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "sfgzfs", $event.target.value)
            }
          }
        }),
        _vm._v("份；合同副本一式"),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.htfbfs,
              expression: "form.htfbfs"
            }
          ],
          staticClass: "width-mini",
          attrs: { type: "text", name: "htfbfs" },
          domProps: { value: _vm.form.htfbfs },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "htfbfs", $event.target.value)
            }
          }
        }),
        _vm._v("份。")
      ]),
      _c("ul", { staticClass: "sys-list-signer" }, [
        _c("li", [
          _vm._v("\n        甲方（盖章）："),
          _c("br"),
          _c("input", {
            staticClass: "width-full",
            attrs: { type: "text" },
            domProps: { value: _vm._f("format")(new Date(), "YYYY年MM月DD日") }
          })
        ]),
        _c("li", [
          _vm._v("\n        乙方（签字）："),
          _c("br"),
          _c("input", {
            staticClass: "width-full",
            attrs: { type: "text" },
            domProps: { value: _vm._f("format")(new Date(), "YYYY年MM月DD日") }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4ebf71c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4ebf71c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/sys-contract/business.vue
// module id = LbvA
// module chunks = 57